var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.indexes.length === 0)?_c('loader'):_vm._e(),_vm._l((_vm.indexes),function(index){return _c('v-col',{key:index.name,staticClass:"col-md-4 cols-sm-12"},[_c('MarketIndexTicker',{attrs:{"ticker":index}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }